"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var useQuery_1 = require("@control4/react-sdk/build/lib/connect-query/useQuery");
var Alert_1 = __importDefault(require("@material-ui/lab/Alert"));
var Form_1 = require("../Form");
/**
 * Handle formik onSubmit event settings the form state to false when async work is done
 * TODO: Move to react-sdk
 * @param onSubmit
 */
var handleOnSubmit = function (runMutation, onSubmit, beforeSubmit, afterSubmit) { return function (values, actions) { return __awaiter(void 0, void 0, void 0, function () {
    var _a, submitValues, response;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0:
                _a = !!beforeSubmit;
                if (!_a) return [3 /*break*/, 2];
                return [4 /*yield*/, beforeSubmit(values, actions)];
            case 1:
                _a = (_b.sent());
                _b.label = 2;
            case 2:
                _a;
                submitValues = values;
                if (!!!onSubmit) return [3 /*break*/, 4];
                return [4 /*yield*/, onSubmit(values, actions)];
            case 3:
                submitValues = _b.sent();
                _b.label = 4;
            case 4: return [4 /*yield*/, runMutation(submitValues)];
            case 5:
                response = _b.sent();
                if (!(!!afterSubmit && response)) return [3 /*break*/, 7];
                return [4 /*yield*/, afterSubmit(response)];
            case 6:
                _b.sent();
                _b.label = 7;
            case 7:
                actions.setSubmitting(false);
                return [2 /*return*/];
        }
    });
}); }; };
/**
 * FormQuery is a especial form that implements a Queryable interface and allows users to send requests and save data to the server in a easy and simple way
 * @param props
 */
var FormQuery = function (props) {
    var _a = react_1.useState(false), isError = _a[0], setIsError = _a[1];
    var _b = react_1.useState(false), isSuccess = _b[0], setIsSuccess = _b[1];
    var _c = useQuery_1.useQuery(props), mutationStatus = _c.mutationStatus, requestStatus = _c.requestStatus, mutate = _c.mutate, data = _c.data;
    var status = {
        mutationStatus: mutationStatus,
        requestStatus: requestStatus,
    };
    var errorMessage = typeof props.errorMessage === 'function' ? props.errorMessage(status) : props.errorMessage;
    var successMessage = typeof props.successMessage === 'function' ? props.successMessage(status) : props.successMessage;
    react_1.useMemo(function () {
        if (mutationStatus && mutationStatus.isFinished) {
            if (props.errorMessage) {
                setIsError(mutationStatus.status !== 200);
            }
            if (props.successMessage) {
                setIsSuccess(mutationStatus.status === 200);
            }
        }
    }, [mutationStatus]);
    react_1.useMemo(function () {
        if (requestStatus && requestStatus.isFinished) {
            if (props.errorMessage) {
                setIsError(requestStatus.status !== 200);
            }
            if (props.successMessage) {
                setIsSuccess(requestStatus.status === 200);
            }
        }
    }, [requestStatus]);
    return (react_1.default.createElement(react_1.default.Fragment, null,
        isError || isSuccess ? (react_1.default.createElement(react_1.default.Fragment, null,
            isError && react_1.default.createElement(Alert_1.default, { severity: "error" }, errorMessage),
            isSuccess && react_1.default.createElement(Alert_1.default, { severity: "success" }, successMessage))) : null,
        react_1.default.createElement(Form_1.Form, __assign({ enableReinitialize: true }, props, { initialValues: data || props.initialValues, onSubmit: handleOnSubmit(mutate, props.onSubmit, props.beforeSubmit, props.afterSubmit) }), function (formikProps) {
            return props.children instanceof Function
                ? props.children(formikProps, {
                    requestStatus: requestStatus,
                    mutationStatus: mutationStatus,
                    data: data,
                })
                : props.children;
        })));
};
exports.default = FormQuery;
//# sourceMappingURL=FormQuery.js.map